import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PayPal from './payments/paypal';
import CreditCard from './payments/creditcard';
import KCOptions from './options/kc';
import CashOptions from './options/cash';
import DRTSOption from './options/drts';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.init({ upc: this.props.product.upc });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.checkout != this.props.checkout) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        if (
            nextProps.checkout.type != this.props.checkout.type
            &&
            (nextProps.checkout.type == 'drts' || this.props.checkout.type == 'drts')
        ) {
            return true;
        }


        return false;
    }

    render({ checkout, mode }) {
        if (mode == 'standard') {
            return (
                <checkout mode={mode}>
                    {this.renderHeader()}
                    <KCOptions mode={mode} />
                    <CashOptions mode={mode} />
                    {this.renderOrderTotal()}
                    <PayPal mode={mode} />
                    <CreditCard mode={mode} />
                    {this.renderError()}
                    {this.renderSecurityMessage()}
                </checkout>
            );
        } else if (mode == 'kc') {
            return (
                <checkout mode={mode}>
                    {this.renderHeader()}
                    {this.renderOrderTotal()}
                    <PayPal mode={mode} />
                    <CreditCard mode={mode} />
                    {this.renderError()}
                    {this.renderSecurityMessage()}
                </checkout>
            );
        } else if (mode == 'drt') {
            return (
                <checkout mode={mode}>
                    {this.renderHeader()}
                    <KCOptions mode={mode} />
                    <DRTSOption mode={mode} />
                    {this.renderOrderTotal()}
                    <PayPal mode={mode} />
                    <CreditCard mode={mode} />
                    {this.renderSubmitButton()}
                    {this.renderError()}
                    {this.renderSecurityMessage()}
                </checkout>
            );
        } else if (mode == 'subscription') {
            return (
                <checkout mode={mode}>
                    {this.renderHeader()}
                    {this.renderSubscriptionCopy()}
                    <row className='is-justified-center'>
                        <column className='is-7 is-12-mobile'>
                            <small>
                                <span className='has-text-color-red'>*</span>
                                <i>Recurring monthly charge</i>
                            </small>
                        </column>
                    </row>
                    {this.renderOrderTotal()}
                    <PayPal mode={mode} />
                    <CreditCard mode={mode} />
                    {this.renderError()}
                    {this.renderSecurityMessage()}
                </checkout>
            );
        }

        return (<checkout mode={mode} />);
    }

    renderHeader = () => {
        return [
            <row className='is-justified-center has-margin-25-top has-margin-10-bottom'>
                <column className='is-7 is-12-mobile'>
                    <h6>REVIEW YOUR ORDER</h6>
                </column>
            </row>,
            <row className='is-wrap is-justified-center is-aligned-center has-margin-30-bottom'>
                <column className='is-7 is-12-mobile'>
                    <h3 className='has-margin-0'>{this.props.product.description}</h3>
                </column>
            </row>,
        ];
    }

    renderSubscriptionCopy = () => {
        if (this.props.product.upc == 'forecast-monthly-subscription') {
            return (
                <row className='is-justified-center'>
                    <column className='is-7 is-12-mobile'>
                        <p>
                            Yes, I want access to a Tarot.com VIP Membership! Please charge
                            ${this.props.product.price} to my card after my 7-day free trial.
                            <sup className='has-text-color-red'>*</sup>
                        </p>
                    </column>
                </row>
            );
        } else if (this.props.product.upc == 'drt-monthly-subscription') {
            return (
                <row className='is-justified-center'>
                    <column className='is-7 is-12-mobile'>
                        <p>
                            Yes, I want three Daily Reflection Tarot Readings every day! Please charge
                            ${this.props.product.price} to my card.
                            <sup className='has-text-color-red'>*</sup>
                        </p>
                    </column>
                </row>
            );
        }

        return null;
    }

    renderOrderTotal = () => {
        if (this.props.mode == 'drt') {
            if (this.props.checkout.type == 'kc' && this.props.user.kcs.total >= this.props.product.price) {
                return (
                    <p className='has-margin-50-top has-margin-30-bottom has-text-center'>
                        <span className='has-padding-20-right'>Order Total</span>
                        <span className='has-text-size-28 has-weight-500'>
                            {parseInt(this.props.product.price)} Karma Coins
                        </span>
                    </p>
                );
            } else if (
                this.props.checkout.type == 'kc'
                &&
                this.props.user.kcs.total < this.props.product.price
            ) {
                return (
                    <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                        <span className='has-padding-20-right'>Order Total</span>
                        <span className='has-text-size-28 has-weight-500'>
                            ${this.props.checkout.package.usd.current}
                        </span>
                    </p>
                );
            } else if (this.props.checkout.type == 'drts') {
                return (
                    <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                        <span className='has-padding-20-right'>Order Total</span>
                        <span className='has-text-size-28 has-weight-500'>${this.props.total.current}</span>
                    </p>
                );
            }
        } else if (this.props.total) {
            if (this.props.total.current != this.props.total.original) {
                return (
                    <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                        <span className='has-padding-20-right'>Order Total</span>
                        <span className='has-text-sushi has-text-size-32 has-weight-500'>
                            ${this.props.total.current}
                        </span>
                        <span className='has-text-size-28 has-weight-500 has-padding-10-left has-text-strikethrough'>
                            ${this.props.total.original}
                        </span>
                    </p>
                );
            }

            return (
                <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                    <span className='has-padding-20-right'>Order Total</span>
                    <span className='has-text-size-28 has-weight-500'>${this.props.total.current}</span>
                </p>
            );
        } else if (this.props.mode == 'subscription') {
            return (
                <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                    <span className='has-padding-20-right'>Order Total</span>
                    <span className='has-text-size-28 has-weight-500'>
                        ${this.props.product.price}
                    </span>
                </p>
            );
        }

        return (
            <p className='has-margin-50-top has-margin-0-bottom has-text-center'>
                <span className='has-padding-20-right'>Order Total</span>
                <span className='has-text-size-28 has-weight-500'>${this.props.checkout.order.usd_total}</span>
            </p>
        );
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <h4
                    className='has-text-center has-text-color-red'
                    dangerouslySetInnerHTML={{ __html: this.props.error }}
                />
            );
        } else if (this.props.checkout && this.props.checkout.order && this.props.checkout.order.finalized) {
            return (
                <h4 className='has-text-center has-text-color-red has-margin-20'>
                    This order was completed on {dayjs(this.props.checkout.order.finalized).format('M/D/YYYY')}
                </h4>
            );
        }

        return null;
    }

    renderSecurityMessage = () => {
        return (
            <row>
                <column className='is-12'>
                    <p className='has-text-center'>
                        We Take Your Security Seriously
                        <br />
                        <small className='has-text-size-13'>
                            Your information is protected with 2048-bit encrypted SSL
                        </small>
                    </p>
                </column>
            </row>
        );
    }

    renderSubmitButton = () => {
        if (
            this.props.mode == 'drt'
            &&
            this.props.checkout.type == 'kc'
            &&
            this.props.user.kcs.total >= this.props.product.price
        ) {
            return (
                <row>
                    <column className='is-12 has-text-center has-padding-15'>
                        <button
                            disabled={this.props.submitting}
                            className={`button ${this.props.submitting ? 'disabled' : ''}`}
                            onClick={this.submitCheckout}
                        >
                            {this.props.submitting ? 'submitting…' : this.props.checkout.button_text}
                        </button>
                    </column>
                </row>
            );
        }

        return null;
    }

    submitCheckout = () => {
        this.props.checkoutSubmit({
            'purchase-package': 'payment-by-kc',
            'subscription_upc': 'drt-monthly-subscription',
            'order_uuid': this.props.checkout.order.order_uuid,
        });
    }
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    total: state.checkout && state.checkout.total,
    error: state.checkout && state.checkout.error,
    product: state.checkout && state.checkout.order && state.checkout.order.items && state.checkout.order.items[0],
    user: state.user,
    submitting: state.checkout && state.checkout.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutSubmit: (payload) => dispatch({ type: 'checkout:kc-only', payload: payload }),
    init: (payload) => dispatch({ type: 'checkout:init', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
